import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEngine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.10557 8.01372C8.27496 7.67494 8.62123 7.46094 9 7.46094H18C18.5523 7.46094 19 7.90865 19 8.46094V15.4609C19 15.7262 18.8946 15.9805 18.7071 16.168L15.7071 19.168C15.5196 19.3556 15.2652 19.4609 15 19.4609H9C8.62123 19.4609 8.27496 19.2469 8.10557 18.9082L7.38197 17.4609H6C5.44772 17.4609 5 17.0132 5 16.4609V10.4609C5 9.90865 5.44772 9.46094 6 9.46094H7.38197L8.10557 8.01372ZM9.61803 9.46094L8.89443 10.9082C8.72504 11.2469 8.37877 11.4609 8 11.4609H7V15.4609H8C8.37877 15.4609 8.72504 15.6749 8.89443 16.0137L9.61803 17.4609H14.5858L17 15.0467V9.46094H9.61803Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 6.46094V7.46094H12V6.46094H11C10.4477 6.46094 10 6.01322 10 5.46094C10 4.90865 10.4477 4.46094 11 4.46094H15C15.5523 4.46094 16 4.90865 16 5.46094C16 6.01322 15.5523 6.46094 15 6.46094H14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 13.4609H19V11.4609H20V10.4609C20 9.90865 20.4477 9.46094 21 9.46094C21.5523 9.46094 22 9.90865 22 10.4609V14.4609C22 15.0132 21.5523 15.4609 21 15.4609C20.4477 15.4609 20 15.0132 20 14.4609V13.4609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 14.4609H5L5 12.4609H4V11.4609C4 10.9087 3.55228 10.4609 3 10.4609C2.44772 10.4609 2 10.9087 2 11.4609L2 15.4609C2 16.0132 2.44772 16.4609 3 16.4609C3.55228 16.4609 4 16.0132 4 15.4609V14.4609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.5743 12.2116L11.7652 13.6276H12.906L12.7519 14.7103L13.5611 13.2943H12.4203L12.5743 12.2116ZM13.8467 12.7943L13.8475 12.7928L13.8467 12.7943ZM11.4787 14.1292L11.4795 14.1277L11.4787 14.1292ZM12.7895 10.0387C12.8697 9.99866 12.9775 9.96094 13.1048 9.96094C13.3044 9.96094 13.4935 10.0412 13.6311 10.1984C13.7733 10.3608 13.8231 10.565 13.7905 10.7633L13.5726 12.2943H14.1631C14.2913 12.2943 14.6291 12.326 14.7752 12.6605C14.8958 12.9359 14.774 13.1872 14.7139 13.2923L12.8244 16.599C12.7544 16.7408 12.6412 16.8309 12.5367 16.8832C12.4566 16.9232 12.3487 16.9609 12.2215 16.9609C12.0219 16.9609 11.8327 16.8807 11.6952 16.7235C11.553 16.561 11.5031 16.3569 11.5358 16.1586L11.7536 14.6276H11.1631C11.0342 14.6276 10.6978 14.5956 10.5511 14.2623L10.5503 14.2604C10.4306 13.9852 10.5524 13.7345 10.6123 13.6295L12.5018 10.3229C12.5719 10.1811 12.685 10.091 12.7895 10.0387Z",
			fill: "currentColor"
		})
	]
});
export default SvgEngine;
